module.exports = __webpack_public_path__ + "static/weltew-sm-detail-8211eed556ec0a5fc461ecf4009de6fc.jpg";